package com.wintermar.inspection.core.ui.component.snackbar.util

import androidx.compose.runtime.Composable
import com.wintermar.inspection.core.ui.theme.LocalAppTheme
import inspection.composeapp.generated.resources.Res
import inspection.composeapp.generated.resources.ic_alert_triangle
import inspection.composeapp.generated.resources.ic_check_circle

sealed class SnackBarVariant {

    @Composable
    abstract fun palette(): SnackBarVariantModel

    object SUCCESS : SnackBarVariant() {
        @Composable
        override fun palette(): SnackBarVariantModel {
            val color = LocalAppTheme.current.color
            return SnackBarVariantModel(
                backgroundColor = color.surface.semantic.success.subtle.default,
                iconColor = color.icon.success.default,
                borderColor = color.border.success,
                icon = Res.drawable.ic_check_circle
            )
        }
    }

    object WARNING : SnackBarVariant() {
        @Composable
        override fun palette(): SnackBarVariantModel {
            val color = LocalAppTheme.current.color
            return SnackBarVariantModel(
                backgroundColor = color.surface.semantic.warning.subtle.default,
                iconColor = color.icon.warning.default,
                borderColor = color.border.warning,
                icon = Res.drawable.ic_alert_triangle
            )
        }
    }

    object INFO : SnackBarVariant() {
        @Composable
        override fun palette(): SnackBarVariantModel {
            val color = LocalAppTheme.current.color
            return SnackBarVariantModel(
                backgroundColor = color.surface.semantic.info.subtle.default,
                iconColor = color.icon.info.default,
                borderColor = color.border.info
            )
        }
    }

    object ERROR : SnackBarVariant() {
        @Composable
        override fun palette(): SnackBarVariantModel {
            val color = LocalAppTheme.current.color
            return SnackBarVariantModel(
                backgroundColor = color.surface.semantic.error.subtle.default,
                iconColor = color.icon.error.default,
                borderColor = color.border.error
            )
        }
    }
}
